import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import ParentService from "services/ParentService";

const initialState = {
  parents: [],
  parent:{},
  loading: false,
  error: null,

};

export const fetchParents = createAsyncThunk(
  "parents/fetchParents",
  async (_, { rejectWithValue }) => {
    try {
      const response = await ParentService.getParents();
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.data.message || "Erreur");
    }
  }
);

export const getOneParent = createAsyncThunk(
  "parents/fetchOneParent",
  async (id, { rejectWithValue }) => {
    try {
      const response = await ParentService.getOneParent(id);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.data.message || "Erreur");
    }
  }
);

export const createParent = createAsyncThunk(
  "parents/createParent",
  async (data, { rejectWithValue }) => {
    try {
      const response = await ParentService.addParent(data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.data.message || "Erreur");
    }
  }
);

export const updateParent = createAsyncThunk(
  "parents/updateParent",
  async ({ id, data }, { rejectWithValue }) => {
    
    try {
      const response = await ParentService.UpdateParent(id, data);
      return { id, updatedParent: response.data };
    } catch (error) {
      return rejectWithValue(error.response?.data?.data.message || "Erreur");
    }
  }
);

export const deleteParent = createAsyncThunk(
  "parents/deleteParent",
  async (id, { rejectWithValue }) => {
    try {
      await ParentService.deleteParent(id);
      return id;
    } catch (error) {
      return rejectWithValue(error.response?.data?.data.message || "Erreur");
    }
  }
);
export const toggleStatusParent = createAsyncThunk(
  "parents/toggleStatusParent",
  async ({id, data}, { rejectWithValue }) => {

    try {
      const response = await ParentService.toggleStatus(id, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data.data.message || "Erreur");
    }
  }
);

const parentsSlice = createSlice({
  name: "parents",
  initialState,
  reducers: {
    

    showLoading: (state) => {
      state.loading = true;
    },
    hideLoading: (state, action) => {
      state.loading = false;
    },
    hideError: (state, action) => {
     
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder

    .addCase(fetchParents.fulfilled, (state, action) => {
      state.parents = action.payload;
      state.loading = false;
      state.error = null;
    })
    .addCase(fetchParents.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(fetchParents.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    })
    .addCase(createParent.fulfilled, (state, action) => {
        state.parents.push(action.payload);
        state.loading = false;
        state.error = null;
    })

  .addCase(createParent.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(createParent.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(updateParent.fulfilled, (state, action) => {
        const { id, updatedParent } = action.payload;
        const parentIndex = state.parents.findIndex(
          (parent) => parent.id === id
        );
        if (parentIndex !== -1) {
          state.parents[parentIndex] = {
            ...state.parents[parentIndex],
            ...updatedParent,
          };
        }
        state.loading = false;
        state.error = null;
      })

      .addCase(updateParent.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(updateParent.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(deleteParent.fulfilled, (state, action) => {
        const parentId = action.payload;
        state.parents = state.parents.filter(
          (parent) => parent.id !== parentId
        );
        state.loading = false;
        state.error = null;
      })

      .addCase(deleteParent.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(deleteParent.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(getOneParent.fulfilled, (state, action) => {
        state.parent = action.payload;
        state.loading = true;
        state.error = null;
      })
      .addCase(getOneParent.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getOneParent.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(toggleStatusParent.pending, (state) => {
        state.loading = true;
      })
      .addCase(toggleStatusParent.fulfilled, (state, action) => {
        const index = state.parents.findIndex(
          (parent) => parent.id === action.payload.id
        );
        state.parents[index] = action.payload;
        state.loading =false
        state.error = null
      
      })
      .addCase(toggleStatusParent.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      }) 
      
  },
});

export default parentsSlice.reducer;
export const { showLoading, hideLoading, hideError } = parentsSlice.actions;